import { render, staticRenderFns } from "./_Table.vue?vue&type=template&id=4b7d62ee&scoped=true&"
import script from "./_Table.vue?vue&type=script&lang=js&"
export * from "./_Table.vue?vue&type=script&lang=js&"
import style0 from "./_Table.vue?vue&type=style&index=0&id=4b7d62ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7d62ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VBtn,VChip,VDataTable,VPagination})
